import { axiosApi } from "../axios";

export const pauseNotification = async (duration,userId:string) => {
    const response = await axiosApi.post(`/users/${userId}/pause/${duration}`);
    return response.status;
  };